import React, { useEffect, useState } from "react"
import "../../../Css/root.css"
import axios from "../../../axios"
import api from "../../../api"
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardMedia from '@mui/material/CardMedia'
import CardActions from '@mui/material/CardActions'
import Dialog from '@mui/material/Dialog'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import LoadingButton from '@mui/lab/LoadingButton'
import SaveIcon from '@mui/icons-material/Save'
import RestoreIcon from '@mui/icons-material/Restore'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import Stack from '@mui/material/Stack'
import Skeleton from '@mui/material/Skeleton'
import BasicCircularProgress from "../../../Components/BasicCircularProgress"
import { styled } from '@mui/material/styles'
import { useSnackbar } from "notistack"

const Input = styled('input')({
    display: 'none',
});

export default function SubjectAddUpdateDialog(props) {
    const [subjectLoading, setSubjectLoading] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false)

    const [title, setTitle] = useState('')
    const [order, setOrder] = useState('')
    const [isActive, setIsActive] = useState(true)
    const [isFree, setIsFree] = useState(false)
    const [banner, setBanner] = useState('')
    const [bannerFile, setBannerFile] = useState('')

    const [errorMessage, setErrorMessage] = useState({})
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    const courseId = props.courseId

    const config = {
        headers: {
            "x-auth-token": localStorage.getItem("user"),
        }
    }

    const bannerUploadconfig = {
        headers: {
            "x-auth-token": localStorage.getItem("user"),
            "Content-Type" : "multipart/form-data"
        }
    }

    function resetFormData() {
        setTitle('')
        setOrder('')
        setIsActive(true)
        setIsFree(false)
        setBannerFile('')
        setErrorMessage({})
    }

    const handleClose = () => {
        props.handleClose()
    }

    const handleReset = () => (
        resetFormData()
    )

    const onUploadBanner = ({ target }) => {
        if(target.files[0]) {
            setBannerFile(target.files[0])
        }
    }

    const handleSubmit = () => {
        if(!isFormDataValid()) return
        props.subjectId ? updateSubject() : addNewSubject()
    }

    const isFormDataValid = () => {
        var isValid = true
        if(!title.length) {
            isValid = false
            setErrorMessage(message => {
                return {...message, title: 'Title must not be empty.'}
            })
        }
        if(!order) {
            isValid = false
            setErrorMessage(message => {
                return {...message, order: 'Order must be a valid number'}
            })
        }
        return isValid
    }

    async function fetchSubjectData(subjectId) {
        setSubjectLoading(true)
        axios
            .get(api.getSubjectById + subjectId, config)
            .then((response) => {
                setTitle(response.data.title)
                setIsActive(response.data.isActive)
                setIsFree(response.data.isFree)
                if(response.data.order) setOrder(response.data.order)
                if(response.data.banner) setBanner(response.data.banner)
                setSubjectLoading(false)
            })
            .catch((error) => {
                enqueueSnackbar("Subject data fetch failed: " + error.response.data, { variant: 'error' })
            })
    }

    async function addNewSubject() {
        setSubmitLoading(true)
        const subjectPayload = {
            title: title,
            chapters: [],
            order: order,
            isFree: isFree,
            isActive: isActive
        }
        axios
            .post(api.createSubject, subjectPayload, config)
            .then((response) => {
                const subjectId = response.data
                axios
                    .post(
                        api.addSubjectToCourse,
                        {
                            subjectId: subjectId,
                            courseId: courseId
                        },
                        config
                    )
                    .then((response) => {
                        enqueueSnackbar(response.data, { variant: 'success' })
                        uploadSubjectBanner(subjectId)
                        setSubmitLoading(false)
                        handleClose()
                        props.handleSuccess()
                    })
                    .catch((error) => {
                        enqueueSnackbar("Add new subject failed: " + error.response.data, { variant: 'error' })
                    })
            })
            .catch((error) => {
                enqueueSnackbar("Add new subject failed: " + error.response.data, { variant: 'error' })
            })
    }

    async function updateSubject() {
        const updatePayload = {
            title: title,
            order: order,
            isFree: isFree,
            isActive: isActive,
        }
        axios
            .put(api.updateSubject + props.subjectId, updatePayload, config)
            .then((response) => {
                enqueueSnackbar(response.data, { variant: 'success' })
                uploadSubjectBanner(props.subjectId)
                handleClose()
                props.handleSuccess()
            })
            .catch((error) => {
                enqueueSnackbar("Update subject failed: " + error.response.data, { variant: 'error' })
            })
    }

    async function uploadSubjectBanner(subjectId) {
        if(!bannerFile) return
        let formData = new FormData()
        formData.append("banner", bannerFile)

        axios.post(api.uploadSubjectBanner + subjectId, formData, bannerUploadconfig)
            .then((response) => {
                enqueueSnackbar(response.data, { variant: 'success' })
            })
            .catch((error) => {
                enqueueSnackbar("Upload subject banner failed: " + error.response.data, { variant: 'error' })
            })
    }

    useEffect(() => {
        // TODO: Stop initial loading
        if(!props.open) {
            return
        }
        if(props.subjectId) fetchSubjectData(props.subjectId)
    }, [props.open])

    const appBar = (
        <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
                <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                    Add or Update Subject
                </Typography>
                <LoadingButton
                    color="secondary"
                    onClick={handleSubmit}
                    loading={subjectLoading || submitLoading}
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="contained"
                >
                    Save
                </LoadingButton>
                <LoadingButton
                    color="inherit"
                    sx={{ ml: 2 }}
                    onClick={handleReset}
                    loading={subjectLoading || submitLoading}
                    loadingPosition="start"
                    startIcon={<RestoreIcon />}
                    variant="contained"
                >
                    Reset
                </LoadingButton>
            </Toolbar>
        </AppBar>
    )

    const titleField = (
        <TextField
            required
            error={!!errorMessage.title}
            variant="outlined"
            label="Title"
            helperText={errorMessage.title}
            sx={{ minWidth: 300 }}
            value={title}
            onChange={(event) => {
                const text = event.target.value
                if(!text.length) {
                    setErrorMessage(message => {
                        return {...message, title: 'Title must not be empty.'}
                    })
                } else {
                    setErrorMessage(message => {
                        return {...message, title: ''}
                    })
                }
                setTitle(event.target.value)
            }}
        />
    )

    const orderField = (
        <TextField
            required
            error={!!errorMessage.order}
            variant="outlined"
            type="number"
            label="Order"
            helperText={errorMessage.order}
            sx={{ minWidth: 300 }}
            value={order}
            onChange={(event) => {
                const order = event.target.value
                if(!order) {
                    setErrorMessage(message => {
                        return {...message, order: 'Order must be a valid number.'}
                    })
                } else {
                    setErrorMessage(message => {
                        return {...message, order: ''}
                    })
                }
                setOrder(event.target.value)
            }}
        />
    )

    const isActiveSwitch = (
        <FormControlLabel
            label="Is Active"
            control={
                <Switch
                    checked={isActive}
                    onChange={(event) => setIsActive(event.target.checked)}
                />
            }
        />
    )

    const isFreeSwitch = (
        <FormControlLabel
            label="Is Free"
            control={
                <Switch
                    checked={isFree}
                    onChange={(event) => setIsFree(event.target.checked)}
                />
            }
        />
    )

    const bannerUploadCard = (
        <Card sx={{ width: 200 }}>
            {
                bannerFile ?
                    <CardMedia
                        component="img"
                        height="118"
                        image={URL.createObjectURL(bannerFile)}
                    /> : (
                        banner ?
                            <CardMedia
                                component="img"
                                height="118"
                                image={"https://cdn.rootsedulive.com/" + banner}
                            /> : <Skeleton variant="rectangular" width={200} height={118} />
                    )
            }
            <CardActions disableSpacing>
                <label htmlFor="subject-banner">
                    <Input onChange={onUploadBanner} accept="image/*" id="subject-banner" type="file" />
                    <Button component="span" size="small">Upload Banner</Button>
                </label>
            </CardActions>
        </Card>
    )

    return (
        <Dialog fullScreen disableEnforceFocus open={Boolean(props.open)} onClose={handleClose}>
            {appBar}
            {subjectLoading && <BasicCircularProgress />}
            <Box sx={{ m: 2 }}>
                <Stack direction="column" spacing={4}>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={4}>
                        {titleField}
                        {orderField}
                    </Stack>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={4}>
                        {isActiveSwitch}
                        {isFreeSwitch}
                    </Stack>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={4}>
                        {bannerUploadCard}
                    </Stack>
                </Stack>
            </Box>
        </Dialog>
    )
}